export default {
  quizQueryParam: 'quiz',
  promoCodeQueryParam: 'promo',
}
